import React, { useState } from 'react';
import './ReportAd.css';

const TIPS = [
  'Please Select the product carefully before you buy.',
  'Refund mike take time so be patient.',
];

function SafetyTips() {
  const [open, setOpen] = useState(false);

  return (
    <div className="safetyTips">
      <button
        type="button"
        className="safetyTipsHeader"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <h4>Safety tips for buyers</h4>
        <span className="safetyTipsToggle">{open ? '−' : '+'}</span>
      </button>
      {open && (
        <ul>
          {TIPS.map((tip, i) => (
            <li key={i}>{tip}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SafetyTips;
